import BuyingOfficeList from "./BuyingOfficeList";

const BuyingOffice = () => {
  return <BuyingOfficeList />;
};

export default BuyingOffice;
